import { render } from "./EmpresasSap.vue?vue&type=template&id=495dbdea&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"empresas\":\"data\",\"obtenerEmpresas\":\"options\"}"
import script from "./EmpresasSap.vue?vue&type=script&lang=js"
export * from "./EmpresasSap.vue?vue&type=script&lang=js"
script.render = render

export default script